import { render } from "./NOMessage.vue?vue&type=template&id=57e4e75c"
import script from "./NOMessage.vue?vue&type=script&lang=js"
export * from "./NOMessage.vue?vue&type=script&lang=js"

import "./NOMessage.vue?vue&type=style&index=0&id=57e4e75c&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "57e4e75c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57e4e75c', script)) {
    api.reload('57e4e75c', script)
  }
  
  module.hot.accept("./NOMessage.vue?vue&type=template&id=57e4e75c", () => {
    api.rerender('57e4e75c', render)
  })

}

script.__file = "src/views/NOMessage.vue"

export default script